import { useState } from "react";
import { AllBanksModal } from "../../../components/modals/AllBanksModal";
import LoadingSpinner from "../../../components/elements/LoadingSpinner";
import { FaPhone, FaWhatsapp } from "react-icons/fa6";
import Pagination from "../../../components/Pagination";
import UpdateCreditLimit from "../../../components/modals/UpdateCreditLimit";

const TableTemplate = ({
  activeTab,
  isLoading,
  setSearchedUser,
  searchedUser,
  data,
  currentPage = 1,
  setCurrentPage,
  totalItems = 0,
}: {
  activeTab: string;
  isLoading: boolean;
  searchedUser?: string;
  setSearchedUser: (user: string) => void;
  data: any[];
  currentPage?: number;
  setCurrentPage?: (page: number) => void;
  totalItems?: number;
}) => {
  const [viewAddress, setViewAddress] = useState({ show: false, address: "" });
  const [userId, setUserId] = useState("");
  const [allBanksModal, setAllBanksModal] = useState(false);
  const [allBanksDetails, setAllBanksDetails] = useState([]);
  const [viewUpdateCreditLimit, setViewUpdateCreditLimit] = useState(false);
  const handlePagination = (pageNumber: number) => {
    setCurrentPage?.(pageNumber);
  };

  const prevPage = () => {
    if (currentPage !== 1) {
      setCurrentPage?.(currentPage - 1);
    }
  };

  const nextPage = () => {
    const maxPage = Math.ceil((totalItems || data.length) / 20);
    if (currentPage !== maxPage) {
      setCurrentPage?.(currentPage + 1);
    }
  };

  const handleUpdateCreditLimit = (data: any) => {
    setUserData(data);
    setViewUpdateCreditLimit((prev) => !prev);
  };
  const [userData, setUserData] = useState([]);

  const handleViewAllBank = (id: string, linkedBanks: any) => {
    setUserId(id);
    setAllBanksDetails(linkedBanks);
    setAllBanksModal((prev) => !prev);
  };

  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <input
          type="text"
          placeholder="Search by email..."
          value={searchedUser}
          onChange={(e) => setSearchedUser(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 text-sm w-64 outline-none focus:border-green-500"
        />
      </div>
      <section className="overflow-x-auto">
        <table className="text-sm font-mont w-full">
          <thead>
            <tr className="bg-[#E9EAEFC2] p-2">
              <th className="p-2 text-nowrap">SN</th>
              <th className="p-2 text-nowrap">Name</th>
              <th className="p-2 text-nowrap">Email</th>
              <th className="p-2 text-nowrap">Phone Number</th>
              <th className="p-2 text-nowrap">Contact</th>
              {activeTab === "individuals" && (
                <th className="p-2 text-nowrap">Account Type</th>
              )}
              {activeTab === "state" && (
                <th className="p-2 text-nowrap">Office Address</th>
              )}
              <th className="p-2 text-nowrap">All Banks</th>
              <th className="p-2 text-nowrap">Credit Score Bal.</th>
              <th className="p-2 text-nowrap">Credit Score</th>
              <th className="p-2 text-nowrap">Open Password</th>
              <th className="p-2 text-nowrap">Action</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={10} className="text-center">
                  <LoadingSpinner />
                </td>
              </tr>
            ) : data.length > 0 ? (
              data.map((user: any, index: number) => (
                <tr key={index}>
                  <td className="p-2 text-center">
                    {index + ((currentPage - 1) * 20) + 1}
                  </td>
                  <td className="p-2 text-nowrap capitalize">
                    {user?.lastName?.toLowerCase()}{" "}
                    {user?.firstName?.toLowerCase()}
                  </td>
                  <td className="p-2">{user?.email}</td>
                  <td className="p-2 text-nowrap">
                    {user?.phoneNumber || "No number"}
                  </td>
                  <td className="p-2">
                    <button
                      className="mr-3"
                      type="button"
                      title="call customer"
                    >
                      <a href={`tel:${user?.phoneNumber}`}>
                        <FaPhone />
                      </a>
                    </button>
                    <button type="button" title="text via whatsapp">
                      <a
                        href={`https://wa.me/${user?.phoneNumber?.replace(
                          /^0/,
                          "234"
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaWhatsapp />
                      </a>
                    </button>
                  </td>
                  {activeTab === "individuals" && (
                    <td className="p-2 text-nowrap">
                      {user?.accountType || "--"}
                    </td>
                  )}
                  {activeTab === "state" && (
                    <td className="p-2 text-nowrap">
                      <button
                        type="button"
                        className="text-secondary text-sm border border-secondary p-2"
                        onClick={() =>
                          setViewAddress({
                            show: true,
                            address: user?.officeAddress,
                          })
                        }
                      >
                        View
                      </button>
                    </td>
                  )}
                  <td className="p-2 text-center">
                    <button
                      className="bg-secondary text-white text-sm rounded-md p-2"
                      onClick={() =>
                        handleViewAllBank(user?._id, user?.linkedBanks)
                      }
                    >
                      View
                    </button>
                  </td>
                  <td className="p-2">
                    ₦
                    {user?.creditScore < 0
                      ? "0"
                      : user?.creditScore?.toLocaleString()}
                  </td>
                  <td className="p-2">
                    ₦{user?.creditLimit?.toLocaleString()}
                  </td>
                  <td className="p-2">
                    {user?.userPassword ? user?.userPassword : "not found"}
                  </td>
                  <td className="p-2 text-nowrap">
                    <button
                      type="button"
                      className="p-2 text-sm text-secondary border border-secondary"
                      onClick={() => handleUpdateCreditLimit(user)}
                    >
                      Update Credit Limit
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} className="text-center text-sm">
                  No Data to show
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </section>
      <section className="p-3 my-5">
        <Pagination
          length={totalItems || data?.length}
          itemsPerPage={20}
          handlePagination={handlePagination}
          currentPage={currentPage}
          prevPage={prevPage}
          nextPage={nextPage}
        />
      </section>
      {viewUpdateCreditLimit && (
        <UpdateCreditLimit
          userData={userData}
          closeModal={() => setViewUpdateCreditLimit(false)}
        />
      )}
      {viewAddress.show && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-5 rounded shadow-lg w-1/3">
            <h2 className="text-lg font-bold mb-4">User Address</h2>
            <p className="text-wrap">
              {viewAddress.address || "No address available"}
            </p>
            <button
              className="mt-4 bg-secondary text-white px-4 py-2 rounded"
              onClick={() => setViewAddress({ show: false, address: "" })}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {allBanksModal && (
        <AllBanksModal
          setAllBanksModal={setAllBanksModal}
          setAllBanksDetails={setAllBanksDetails}
          allBanksDetails={allBanksDetails}
          setSearchedUser={setSearchedUser}
          userId={userId}
        />
      )}
    </>
  );
};

export default TableTemplate;
